import React, { useState } from 'react';
import { Edit2, Save, X } from 'lucide-react';
import { FooterSettings } from '../../services/settings';

interface FooterManagementProps {
  footer: FooterSettings;
  onChange: (footer: FooterSettings) => void;
}

export const FooterManagement: React.FC<FooterManagementProps> = ({
  footer,
  onChange
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedFooter, setEditedFooter] = useState(footer);

  const handleSave = () => {
    onChange(editedFooter);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditedFooter(footer);
    setIsEditing(false);
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        {!isEditing ? (
          <button
            onClick={() => setIsEditing(true)}
            className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700"
          >
            <Edit2 className="w-4 h-4" />
            Modifier
          </button>
        ) : (
          <div className="flex items-center gap-2">
            <button
              onClick={handleCancel}
              className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-700"
            >
              <X className="w-4 h-4" />
              Annuler
            </button>
            <button
              onClick={handleSave}
              className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700"
            >
              <Save className="w-4 h-4" />
              Enregistrer
            </button>
          </div>
        )}
      </div>

      <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Adresse
            </label>
            <input
              type="text"
              value={editedFooter.address}
              onChange={(e) => setEditedFooter({ ...editedFooter, address: e.target.value })}
              disabled={!isEditing}
              className="w-full rounded-lg border border-gray-300 dark:border-gray-600 p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Téléphone
            </label>
            <input
              type="text"
              value={editedFooter.phone}
              onChange={(e) => setEditedFooter({ ...editedFooter, phone: e.target.value })}
              disabled={!isEditing}
              className="w-full rounded-lg border border-gray-300 dark:border-gray-600 p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Mobile
            </label>
            <input
              type="text"
              value={editedFooter.mobile}
              onChange={(e) => setEditedFooter({ ...editedFooter, mobile: e.target.value })}
              disabled={!isEditing}
              className="w-full rounded-lg border border-gray-300 dark:border-gray-600 p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Email
            </label>
            <input
              type="email"
              value={editedFooter.email}
              onChange={(e) => setEditedFooter({ ...editedFooter, email: e.target.value })}
              disabled={!isEditing}
              className="w-full rounded-lg border border-gray-300 dark:border-gray-600 p-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed"
            />
          </div>
        </div>
      </div>
    </div>
  );
};